{
  "event_passed": "O evento já ocorreu e, por isso, já não está disponível",
  "pos_age_confirmation": "Confirmo que eu e as outras pessoas para quem estou a solicitar bilhetes temos pelo menos {minimum_age} ou mais.",
  "next": "Seguinte",
  "pos_open": "Comprar bilhetes",
  "view_pos_title": "Visão geral do produto para {event_name}",
  "pos_sale_ends_in_months_days": "A promoção termina em {months} mês(s) e {days} dia(s)",
  "pos_sale_ends_in_months": "A promoção termina em {months} mês(es)",
  "pos_sale_ends_in_minutes": "A promoção termina em {minutes} minuto(s)",
  "pos_sale_ends_in_hours": "A promoção termina em {hours} horas",
  "pos_sale_ends_in_days_and_hours": "A promoção termina em {days} dia(s) e {hours} hora(s)",
  "product_sale_starts_at": "A venda começa em",
  "pos_sale_ended_at": "A venda terminou às",
  "order_timeslot": "Horários",
  "shop_timeslot": "Horários",
  "discount_code_claim": "Reclamação",
  "pos_overview_read_less": "Leia menos",
  "customer_form_custom_questions": "Por favor responda às seguintes questões",
  "cart_terms_conditions2": "Ao clicar no botão 'Continuar', confirma que leu e concorda com os <a href='{url}' target='_blank'>Termos e Condições</a> e <a href='https://fairtix.io/en/privacy-policy' target='_blank'>Política de Privacidade</a> da Fairtix e os <a href='{url2}' target='_blank'>Termos e Condições</a> de {name}",
  "order_loading": "Carregando o seu pedido",
  "order_already_paid": "Encomenda já paga!",
  "pos_personal_details_title": "Detalhes pessoais",
  "customer_form_click_on_claim_button": "Clique no botão Solicitar ticket para enviar o ticket para o seu endereço de e-mail",
  "ticket_claim_copy_order_data": "Copiar dados pessoais do pedido",
  "customer_address": "Endereço completo",
  "customer_house_nr": "Casa não",
  "customer_city": "Cidade do cliente",
  "errors_please_select": "Por favor selecione uma opção",
  "date_format": "dd-mm-aaaa",
  "customer_email_suggestion": "Queria dizer {full}?",
  "yes": "Sim",
  "no": "Não",
  "customer_form_email_confirmation_not_match": "Emails não coincidem",
  "customer_optin_iams": "Sim, gostaria de receber e-mails da IAMS para ter a oportunidade de ganhar prémios incríveis e experiências VIP",
  "customer_gender_male": "Macho",
  "customer_gender_female": "Fêmea",
  "customer_gender_other": "outro",
  "birth_date_must_be_past": "A data de nascimento deve estar no passado",
  "payment_failed": "Pagamento falhou!",
  "pos_free_order_btn": "Continue a fazer o pedido",
  "payment_loading": "Pagamento de carregamento...",
  "error_select_payment_method": "Selecione um método de pagamento",
  "pos_payment_method_title": "Métodos de Pagamento",
  "order_cancelled": "O pedido foi cancelado",
  "order_pick_timeslot": "Escolha o seu horário",
  "order_pick_date": "Escolha a sua data",
  "error_try_again": "Ocorreu um erro.",
  "download_tickets": "Baixar bilhetes",
  "order_status_alert_pending": "O seu pagamento ainda não foi efetuado, o nosso fornecedor de serviços de pagamento verificará esse pagamento manualmente. Isto pode levar várias horas.",
  "order_status_alert_not_paid": "O seu pagamento não foi processado ou não foi aceite pelo nosso fornecedor de serviços de pagamento.",
  "order_status_ticket_not_assigned": "Ainda não registado para nome",
  "order_status_product_refunded": "Reembolsado em {refunded_at}",
  "order_status_product_cancelled": "Cancelado",
  "order_status_put_on_name": "Atribuir nome",
  "order_status_product_invited_at": "Convidado em {invited_at}",
  "download": "Transferir",
  "pos_overview_read_more": "Consulte Mais informação",
  "shop_questions_event": "Perguntas sobre o evento?",
  "shop_questions_event_hint": "O nosso serviço de apoio ao cliente está sempre disponível para si. Basta escrever um e-mail ou ligar para o número seguinte!",
  "shop_chamber_of_commerce_number": "Número da Câmara de Comércio:",
  "shop_questions_tickets": "Perguntas sobre os bilhetes?",
  "shop_questions_tickets_hint": "Se tiver alguma dúvida, pode sempre contactar a Fairtix. Basta escrever um e-mail ou ligar para o número seguinte!",
  "address": "Morada",
  "shop_tickets": "Bilhetes",
  "shop_personal_details": "Dados pessoais",
  "shop_pay": "Pagamento",
  "cart_empty": "O seu carrinho está vazio, adicione alguns produtos",
  "view_pos_cart_title": "Escolha os seus bilhetes",
  "cart_order": "Continuar",
  "view_pos_minimum_age": "A idade mínima para este evento é de {minimum_age} anos",
  "pos_product_expired": "Expirado",
  "pos_product_sold_out": "Esgotado",
  "pos_sale_ends_in_months_days_and_hours": "A promoção termina em {months} mês(s), {days} dia(s) e {hours} hora(s)",
  "event_nav_timeslots": "Horários",
  "cart_title": "Resumo da encomenda",
  "cart_sub_total": "Subtotal",
  "cart_ticket_fee": "Encargos administrativos",
  "cart_incl_vat": "IVA incluído",
  "cart_clear": "Limpar o carrinho",
  "back": "Voltar",
  "discountcode_add_to_cart": "Adicionar código de desconto",
  "ticket_claim": "Reivindicar um bilhete",
  "order_expires_in": "Se não concluir a sua encomenda a tempo, esta será automaticamente cancelada. Dispõe de {timeLeft} minutos para concluir a sua encomenda.",
  "customer_form_title": "Introduza os seus dados pessoais",
  "customer_first_name": "Nome",
  "customer_last_name": "Apelido",
  "customer_email": "Endereço de e-mail",
  "email_confirmation": "Confirmar o e-mail",
  "customer_optin": "Gostaria de receber informações deste organizador",
  "cart_terms_conditions": "Ao clicar no botão 'Continuar', confirma que leu e concorda com os <a href='{url}' target='_blank'>Termos e Condições</a> e <a href='https://fairtix.io/en/privacy-policy' target='_blank'>Política de Privacidade</a> da Fairtix",
  "order_continue": "Efetuar encomenda",
  "customer_company_name": "Nome da empresa",
  "customer_zip": "Código postal",
  "customer_country": "País",
  "customer_dob": "Data de nascimento",
  "customer_phone": "Número de telefone",
  "customer_gender": "Sexo",
  "order_payment_method": "Selecionar um método de pagamento",
  "order_thank_you": "Obrigado pela sua encomenda #{order_number}",
  "order_thank_you_text": "A sua encomenda está agora concluída.",
  "order_thank_you_btn_ticket_download": "Transferir bilhetes",
  "order_thank_you_upcoming_events": "Não perca também estes eventos",
  "order_thank_you_btn_event_details": "ENCOMENDAR AGORA",
  "order_status_number": "A sua encomenda #{order_number}",
  "order_status_ticket_generating": "O bilhete está a ser emitido",
  "order_status_ticket_merging": "Os bilhetes estão a ser fundidos",
  "order_status_alert_cancelled": "O seu pedido foi cancelado",
  "order_status_alert_refunded": "O seu pedido foi reembolsado",
  "order_status_title": "Visão geral do pedido",
  "lang_nl": "Holandês",
  "lang_de": "Alemão",
  "lang_en": "Inglês",
  "lang_es": "Espanhol",
  "lang_fr": "Francês",
  "lang_pt": "Português",
  "pos_buy_your_tickets": "Compre já os seus bilhetes!",
  "pos_timeslot_choose_the_time":"Escolha a hora da sua visita",
  "pos_personal_details": "Dados pessoais",
  "pos_personal_details_complete_purchase":"Conclua a sua compra",
  "pos_payment": "Pagamento",
  "pos_payment_description":"Escolha um método de pagamento",
  "pos_order_success_title": "A sua encomenda: #{order_number} foi efectuada com sucesso!",
  "event_product_persons":"Número de pessoas",
  "persons": "Pessoas",
  "pos_place_order_total":"Total (incl. IVA & €{total} custos de reserva)",
  "pos_place_order_got_a_code": "Tem um código?",
  "read_more": "Ler mais",
  "read_less": "Ler menos",
  "layout_accent_color": "Cor de destaque",
  "layout_description_color": "Cor da descrição",
  "layout_buttons_color": "Cor do botão",
  "layout_button_text_color": "Cor do texto do botão",
  "signup_create_account": "Criar conta",
  "signup_enter_details": "Criar a conta é completamente gratuito!",
  "signup_chamber_of_commerce": "Câmara de comércio",
  "signup_iban": "IBAN",
  "signup_iban_holder_name": "Nome do titular da conta IBAN",
  "signup_confirm_password": "Confirmar senha",
  "signup_terms": "Eu concordo com os <a target='_blank' href='https://fairtix.io/en/terms-conditions'>Termos e Condições</a> e declaro que estou autorizado a assinar em nome da organização especificada",
  "signup_already_user": "Já tem uma conta?",
  "signup_loading_creating_account": "Criando conta...",
  "signup_loading_configuring_the_layout": "Configurando o layout...",
  "signup_loading_almost_done": "Quase lá...",
  "signup_loading_go_to_dashboard": "Ir para o painel como usuário logado",
  "signup_step_2_title": "Completar a conta",
  "signup_step_2_enter_details": "Forneça os últimos detalhes",
  "signup_confirm_account": "Confirmar seus dados",
  "signup_password_strength": "A senha deve ter pelo menos 8 caracteres, 1 número, 1 letra, 1 maiúscula e 1 caractere especial",
  "pos_buy_extra_products": "Compre produtos extras",
  "pos_fill_in_discount_code": "Insira o seu código de desconto",
  "discount_code": "Código de desconto",
  "something_went_wrong": "Une erreur s'est produite",
  "btn_apply": "Aplicar",
  "pos_use_discount_code": "Utilizar código de desconto"
}